import React from 'react';
import { Layout as ReactAdminLayout } from 'react-admin';
import AppBar from './AppBar';

const Layout = (props) => <ReactAdminLayout {...props} appBar={AppBar} />;

export default Layout;
